import { render } from "./D-Responsive.vue?vue&type=template&id=3fa7a28c&scoped=true"
import script from "./D-Responsive.vue?vue&type=script&lang=js"
export * from "./D-Responsive.vue?vue&type=script&lang=js"

import "./D-Responsive.vue?vue&type=style&index=0&id=3fa7a28c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa7a28c"]])

export default __exports__